import React from "react";
import { Typography, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import * as Icons from "@material-ui/icons";
import FormLoadingComponent from "../../../../Components/FormLoading";
import CardStyle from "../../../../Components/CardStyle";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "90%",
    padding:"0.2rem",
    [theme.breakpoints.up("xs")]: {height: "110px"},
    [theme.breakpoints.up("sm")]: {height: "110px"},
    [theme.breakpoints.up("md")]: {height: "110px"},
    [theme.breakpoints.up("lg")]: {height: "110px"},
    [theme.breakpoints.up("xl")]: {height: "110px"},  
  },
  title:{
    fontWeight: "bold",
    fontFamily: "sans-serif",
    [theme.breakpoints.up("xs")]: { fontSize: "1.3rem"},   
    [theme.breakpoints.up("sm")]: { fontSize: "1.4rem"},     
    [theme.breakpoints.up("md")]: { fontSize: "1.2rem"},  
    [theme.breakpoints.up("lg")]: { fontSize: "1.2rem"},  
    [theme.breakpoints.up("xl")]: { fontSize: "1.2rem"},  
  },
  subtitle:{
    fontWeight: "bold",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    [theme.breakpoints.up("xs")]: { fontSize: "1.9rem"},   
    [theme.breakpoints.up("sm")]: { fontSize: "1.9rem"},     
    [theme.breakpoints.up("md")]: { fontSize: "1.7rem"},  
    [theme.breakpoints.up("lg")]: { fontSize: "1.7rem"},  
    [theme.breakpoints.up("xl")]: { 
      fontSize: "1.7rem",
      "@media (min-width: 1920px)": {
        fontSize: "1.5rem"
      },
      "@media (min-width: 2560px)": {
        fontSize: "1.3rem"
      },
      "@media (min-width: 3840px)": {
        fontSize: "1.1rem"
      }
    },  
  },
  avatar: {
    color: "black",
    [theme.breakpoints.up("xs")]: {width: theme.spacing(5), height: theme.spacing(5)},      
    [theme.breakpoints.up("sm")]: {width: theme.spacing(6), height: theme.spacing(6)},     
    [theme.breakpoints.up("md")]: {width: theme.spacing(6), height: theme.spacing(6)},    
    [theme.breakpoints.up("lg")]: {width: theme.spacing(6), height: theme.spacing(6)},    
    [theme.breakpoints.up("xl")]: {width: theme.spacing(6), height: theme.spacing(6)},    
  },
  large: {
    [theme.breakpoints.up("xs")]: {width: theme.spacing(6), height: theme.spacing(6),},   
    [theme.breakpoints.up("sm")]: {width: theme.spacing(8), height: theme.spacing(8),},     
    [theme.breakpoints.up("md")]: {width: theme.spacing(7), height: theme.spacing(7),},  
    [theme.breakpoints.up("lg")]: {width: theme.spacing(7), height: theme.spacing(7),},  
    [theme.breakpoints.up("xl")]: {width: theme.spacing(7), height: theme.spacing(7),},  
  },
}));

const formatCurrency = (value) => {
  if (value === undefined) return <Skeleton variant="text" width="2rem"/>;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(parseFloat(value));
};

export const CardProjects = ({value}) => {
  const classes = useStyles();
  return (
    <CardStyle
    primary={<Typography className={classes.title} component="h1" color="textPrimary">
              Projetos
             </Typography>}
   
    value={<Typography className={classes.subtitle} component="h2" color="textSecondary">
            {value !== undefined ? value : <Skeleton variant="text" width="2rem"/>}
           </Typography>}
           
    color="linear-gradient(60deg,rgba(3,155,229,1) 20%,#00CED1 100%)"
    customIcon={Icons.WebAsset}
   />
      // <Card elevation={1} className={classes.root}>
      //   <CardHeader style={{justifyContent:"space-between", display: "flex", alignContent: "start", alignItems: "start", textAlign:"center"}}
      //    avatar={ 
      //     <Avatar className={classes.large} style={{backgroundColor: "white"}} >
      //      <Icons.WebAsset className={classes.avatar} />
      //    </Avatar>}
      //    title={
      //      <Typography className={classes.title} component="h1" color="textPrimary">
      //       Projetos
      //      </Typography>}
      //     subheader={
      //       <Typography className={classes.subtitle} component="h2" color="textSecondary">
      //       {value !== undefined ? value : <FormLoadingComponent />}
      //     </Typography>}
      //   />  
      // </Card>
  );
};

export const CardSecretary = ({value}) => {
  const classes = useStyles();
  return (
    <CardStyle
    primary={<Typography className={classes.title} component="h1" color="textPrimary">
              Secretarias
             </Typography>}
   
    value={<Typography className={classes.subtitle} component="h2" color="textSecondary">
            {value !== undefined ? value : <Skeleton variant="text" width="2rem"/>}
           </Typography>}
           
    color="linear-gradient(60deg, rgba(251,140,0,1) 0%, rgba(255,202,41,1) 100%)"
    customIcon={Icons.AccountBalance}
   />
      // <Card elevation={1} className={classes.root}>
      //   <CardHeader style={{justifyContent:"space-between", display: "flex", alignContent: "start", alignItems: "start", textAlign:"center"}}
      //    avatar={ 
      //     <Avatar className={classes.large} style={{backgroundColor: "white"}} >
      //      <Icons.AccountBalance variant="h4" className={classes.avatar}/>
      //    </Avatar>}
      //    title={
      //     <Typography className={classes.title} component="h1" color="textPrimary">
      //       Secretarias
      //      </Typography>}
      //     subheader={
      //       <Typography className={classes.subtitle} component="h2" color="textSecondary">
      //       {value !== undefined ? value : <FormLoadingComponent />}
      //     </Typography>}
      //   />  
      // </Card>
  );
};

export const CardSuspendedProjects = ({value}) => {
  const classes = useStyles();
  return (
    <CardStyle
    primary={<Typography className={classes.subtitle} component="h2" color="textSecondary" title={formatCurrency(value)}>
            {formatCurrency(value)}
           </Typography>}
   
    value={<Typography className={classes.title} component="h1" color="textPrimary">
              Suspensos
             </Typography>}
           
    color="linear-gradient(60deg, rgba(255,152,0,1) 0%, rgba(255,193,7,1) 100%)"
    customIcon={Icons.PauseCircleOutline}
   />
  );
};

export const CardCanceledProjects = ({value}) => {
  const classes = useStyles();
  return (
    <CardStyle
    primary={<Typography className={classes.subtitle} component="h2" color="textSecondary" title={formatCurrency(value)}>
            {formatCurrency(value)}
           </Typography>}
   
    value={<Typography className={classes.title} component="h1" color="textPrimary">
              Cancelados
             </Typography>}
           
    color="linear-gradient(60deg, rgba(244,67,54,1) 0%, rgba(239,83,80,1) 100%)"
    customIcon={Icons.Cancel}
   />
  );
};

export const CardInProgressProjects = ({value}) => {
  const classes = useStyles();
  return (
    <CardStyle
    primary={<Typography className={classes.subtitle} component="h2" color="textSecondary" title={formatCurrency(value)}>
            {formatCurrency(value)}
           </Typography>}
   
    value={<Typography className={classes.title} component="h1" color="textPrimary">
              Em Andamento
             </Typography>}
           
    color="linear-gradient(60deg, rgba(76,175,80,1) 0%, rgba(102,187,106,1) 100%)"
    customIcon={Icons.PlayCircleOutline}
   />
  );
};

export const CardNotStartedProjects = ({value}) => {
  const classes = useStyles();
  return (
    <CardStyle
    primary={<Typography className={classes.subtitle} component="h2" color="textSecondary" title={formatCurrency(value)}>
            {formatCurrency(value)}
           </Typography>}
   
    value={<Typography className={classes.title} component="h1" color="textPrimary">
              Não Iniciados
             </Typography>}
           
    color="linear-gradient(60deg, rgba(158,158,158,1) 0%, rgba(189,189,189,1) 100%)"
    customIcon={Icons.Schedule}
   />
  );
};

export const CardCompletedProjects = ({value}) => {
  const classes = useStyles();
  return (
    <CardStyle
    primary={<Typography className={classes.subtitle} component="h2" color="textSecondary" title={formatCurrency(value)}>
            {formatCurrency(value)}
           </Typography>}
   
    value={<Typography className={classes.title} component="h1" color="textPrimary">
              Concluídos
             </Typography>}
           
    color="linear-gradient(60deg, rgba(33,150,243,1) 0%, rgba(66,165,245,1) 100%)"
    customIcon={Icons.CheckCircleOutline}
   />
  );
};

export const CardProjectsTotal = ({value}) => {
  const classes = useStyles();
  return (
    <CardStyle
    primary={<Typography className={classes.subtitle} component="h2" color="textSecondary" title={formatCurrency(value)}>
            {Number.isNaN(value) ? <Skeleton variant="text" width="2rem"/> : formatCurrency(value)}
           </Typography>}
    value={<Typography className={classes.title} component="h1" color="textPrimary">
              Total dos Projetos
             </Typography>}
           
    color="linear-gradient(60deg, rgba(33,150,243,1) 0%, rgba(66,165,245,1) 100%)"
    customIcon={Icons.WebAsset}
   />
  );
};

 
// export const CardProjects = ({ value }) => {
//   return (
//       <Card>
//         <CardContent>
//           <Grid
//             container
//             direction="row"
//             justify="space-between"
//             alignItems="center"
//           >
//             <Grid item xl={4}>
//               <WebAsset style={{ borderRadius: 10, fontSize: 60 }} />
//             </Grid>
//             <Grid item xl={6}>
//               <Typography
//                 style={{
//                 //  fontSize: 20,
//                   fontWeight: "bold",
//                   textAlign: "center",
//                 }}
//                 variant="h5"
//               >
//                 Projetos
//               </Typography>
//               <Typography
//                 style={{
//                 //  fontSize: 30,
//                   fontWeight: "bold",
//                   color: "#CCC",
//                   textAlign: "center",
//                 }}
//                 variant="h5"
//               >
//                 {value !== undefined ? <>{value}</> : <FormLoadingComponent />}
//               </Typography>
//             </Grid>
//           </Grid>
//         </CardContent>
//       </Card>
//   );
// };

// export const CardSecretary = ({ value }) => {
//   return (
//       <Card>
//         <CardContent>
//           <Grid
//             container
//             direction="row"
//             justify="space-between"
//             alignItems="center"
//           >
//             <Grid item xl={4}>
//               <AccountBalance style={{ borderRadius: 10, fontSize: 60 }} />
//             </Grid>
//             <Grid item xl={6}>
//               <Typography
//                 style={{
//                 //  fontSize: 20,
//                   fontWeight: "bold",
//                   textAlign: "center",
//                 }}
//                 variant="h5"
//               >
//                 Secretarias
//               </Typography>
//               <Typography
//                 style={{
//                 //  fontSize: 30,
//                   fontWeight: "bold",
//                   color: "#CCC",
//                   textAlign: "center",
//                 }}
//                 variant="h5"
//               >
//                {value !== undefined ? <>{value}</> : <FormLoadingComponent />}
//               </Typography>
//             </Grid>
//           </Grid>
//         </CardContent>
//       </Card>
//   );
// };
 